import React, { useCallback, useEffect, useState, useRef } from 'react';
import styles from './index.less';
import FrozenRatio from '../FrozenRatio/FrozenRatio';
import Link from 'next/link';
import router from 'next/router';
import UnoptimizedImage from '../UnoptimizedImage';

function CustomerVoice({ img, restaurantName, desc, location, order = 'normal', link, darkMode = true }) {
  const onClick = useCallback(() => {
    link &&
      router.push({
        pathname: `${link}`,
      });
  }, []);

  return (
    <div className={`${styles.CustomerVoice} ${darkMode ? '' : styles.lightMode}`}>
      <div className="customer-voice-card" onClick={onClick}>
        <div className="customer-voice-left-section" style={{ order: order === 'normal' ? 1 : 3 }}>
          <FrozenRatio ratio={0.8125}>
            {/* <img  /> */}
            <UnoptimizedImage src={img} alt={`${restaurantName}, ${location}`} layout="fill" />
          </FrozenRatio>
        </div>
        <div className="customer-voice-card-gap" style={{ width: '32px', order: 2 }} />
        <div className="customer-voice-right-section" style={{ order: order === 'normal' ? 3 : 1 }}>
          <p className="customer-voice-content">{desc}</p>
          <p className="customer-voice-name-address">
            <span>{restaurantName}</span>
            <span>{location}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default CustomerVoice;
